<template>
	<div class="signup-popup signup-step-1">
		<form @submit.prevent="onSubmit">
			<div class="popup-wrapper">
				<header class="popup-header" :style="{ 'background-image': `url(${images.header})` }" />
				<div class="popup-content">
					<h1 class="popup-title">Welcome to Enwoke</h1>
					<p>
						THE ENWOKE social commerce solution helps you connect with a world of professional networks,
						find content for your websites and contribute your own stories. Please follow these steps to
						set-up your Enwoke account and help your with the features of the platform. You can also skip
						the assistant and restart it at a later time from the settings menu.
					</p>
					<p>
						<input
							type="email"
							placeholder="Email address"
							required
							maxlength="100"
							v-model="formData.email"
						/>
					</p>
					<div class="alert alert-danger" v-if="isEmailExists">
						This email already in use on another account.
					</div>
					<p>
						<label for="isAgreeEnwokeTerms">
							<input type="checkbox" v-model="isAgreeEnwokeTerms" id="isAgreeEnwokeTerms" />
							<span>I agree to the ENWOKE terms &amp; conditions</span>
						</label>
					</p>
					<SocialLogin @loggedin="onSocialLoggedIn" />
				</div>
			</div>
			<div class="popup-actions">
				<router-link to="/signin" class="text-button">Back</router-link>
				<button type="submit" class="btn btn-primary" :disabled="!isFormValid">Continue Setup</button>
			</div>
		</form>
	</div>
</template>

<script>
import headerBg from '@/assets/images/bg-header-popup.jpg';
import SocialLogin from '@/components/SocialLogin';

export default {
	components: {
		SocialLogin,
	},
	data() {
		return {
			images: {
				header: headerBg,
			},
			formData: {
				id: '',
				email: '',
			},
			isAgreeEnwokeTerms: false,
			isEmailExists: false,
		};
	},
	computed: {
		isFormValid() {
			return this.formData.email && this.formData.email.trim() !== '' && this.isAgreeEnwokeTerms;
		},
	},
	methods: {
		onSubmit() {
			if (!this.isFormValid) return;

			this.formData.email = this.formData.email.trim();

			this.$repo.user
				.isExistsBusinessUserEmail(this.formData.email)
				.then(async (isExists) => {
					this.isEmailExists = isExists;
					if (!isExists) {
						this.$store.commit('setSignupUser', this.formData);
						this.emitSubmit();
					}
				})
				.catch(console.error);
		},
		onSocialLoggedIn(data) {
			this.formData.id = data.user.id;
			this.$store.commit('setSignupUser', this.formData);

			// Assign exists data to personal info form.
			this.$repo.user
				.getPersonalInfo()
				.then((data) => {
					const { firstName, lastName, telephone, city, country } = data;
					this.$store.commit('setSignupUser', {
						firstName,
						lastName,
						telephone,
						city,
						country,
					});
					this.emitSubmit();
				})
				.catch((err) => {
					console.error(err);
				});
		},
		emitSubmit() {
			this.$emit('submit', this.formData);
		},
		loadFromStore() {
			this.formData.id = this.$store.state.signup.user.id;
			this.formData.email = this.$store.state.signup.user.email;
		},
	},
	mounted() {
		this.loadFromStore();
	},
};
</script>

<style lang="scss"></style>
